<template>
  <v-main>
    <v-dialog v-model="showSucces" color="white" persistent width="500">
      <v-alert color="green" class="ma-0" dark prominent icon="mdi-check-bold">
        <span class="headline">{{ mensajeOk }}</span>
        <v-divider class="my-4 white" style="opacity: 0.22"></v-divider>
        <v-row no-gutters class="justify-end">
          <v-col class="shrink">
            <v-btn outlined @click="showSucces = false"
              >{{ $t('sucursal.cerrar') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-alert>
    </v-dialog>

    <v-dialog v-model="showError" persistent width="500">
      <v-card>
        <v-card-title class="headline red" primary-title
          >{{ $t('sucursal.error') }}
        </v-card-title>
        <v-card-text class="body-1">
          {{ mensajeError }}
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn color="primary" text @click="showError = false">
            {{ $t('sucursal.aceptar') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-card v-if="showLoading" width="100%">
      <v-card-text>
        {{ $t('sucursal.cargando') }}
        <v-progress-circular indeterminate color="primary" class="mb-0" />
      </v-card-text>
    </v-card>
    <v-card v-if="sucursal !== null" class="my-2 mx-1 pa-0 text-center">
      <v-card-title class="blue lighten-3">
        {{ sucursal.razon_social }}
      </v-card-title>
      <div>
        <v-form>
          <v-container>
            <v-row>
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  v-model="sucursal.razon_social"
                  :hide-details="true"
                  :label="$t('sucursal.nombreDeSucursal')"
                  :placeholder="$t('sucursal.raznSocial')"
                />
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  v-model="sucursal.direccion"
                  :hide-details="true"
                  :label="$t('sucursal.direccion')"
                  :placeholder="$t('sucursal.direccion3Points')"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6">
                <v-autocomplete
                  v-model="sucursal.provincia_id"
                  :items="provincias"
                  item-text="nombre"
                  item-value="id"
                  attach
                  chips
                  :label="$t('sucursal.provincia')"
                  hide-details
                  @change="cambiarProvincia()"
                />
              </v-col>
              <v-col cols="12" sm="8">
                <v-autocomplete
                  v-model="sucursal.localidad_id"
                  :items="localidades"
                  :loading="showLoadingLocalidades"
                  item-text="nombre"
                  item-value="id"
                  attach
                  chips
                  :label="$t('sucursal.localidad')"
                  hide-details
                  @change="cambiarLocalidad()"
                />
              </v-col>
              <v-col cols="12" sm="4">
                <v-text-field
                  v-model="sucursal.cod_postal"
                  :hide-details="true"
                  :label="$t('sucursal.codigoPostal')"
                  :placeholder="$t('sucursal.codigoPostal3Points')"
                />
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  v-model="sucursal.tel_1"
                  :hide-details="true"
                  :label="$t('sucursal.telefonoPrincipal')"
                  :placeholder="$t('sucursal.telefono3Points')"
                />
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  v-model="sucursal.tel_2"
                  :hide-details="true"
                  :label="$t('sucursal.telfonoAlternativo')"
                  :placeholder="$t('sucursal.telefono3Points')"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  v-model="sucursal.contacto"
                  :hide-details="true"
                  :label="$t('sucursal.contacto')"
                  :placeholder="$t('sucursal.contacto3Points')"
                />
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  v-model="sucursal.email"
                  :hide-details="true"
                  :label="$t('sucursal.email')"
                  :placeholder="$t('sucursal.email3Points')"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="4">
                <v-checkbox
                  v-model="sucursal.entrega_domicilio"
                  :label="$t('sucursal.entregaADomicilio')"
                  hide-details
                />
              </v-col>
              <v-col cols="12" sm="4">
                <v-checkbox
                  v-model="sucursal.entrega_todo_pais"
                  :label="$t('sucursal.entregaATodoElPas')"
                  hide-details
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="4">
                <v-text-field
                  v-model="sucursal.contacto_admin"
                  :hide-details="true"
                  :label="$t('sucursal.contactoAdministrativo')"
                  :placeholder="$t('sucursal.contacto3Points')"
                />
              </v-col>
              <v-col cols="12" sm="4">
                <v-text-field
                  v-model="sucursal.telefono_admin"
                  :hide-details="true"
                  :label="$t('sucursal.telfonoAdministrativo')"
                  :placeholder="$t('sucursal.telefono3Points')"
                />
              </v-col>
              <v-col cols="12" sm="4">
                <v-text-field
                  v-model="sucursal.email_admin"
                  :hide-details="true"
                  :label="$t('sucursal.emailAdministrativo')"
                  :placeholder="$t('sucursal.email3Points')"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  v-model="sucursal.lat"
                  :hide-details="true"
                  :label="$t('sucursal.latitud')"
                  :placeholder="$t('sucursal.latitud3Points')"
                  disabled
                />
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  v-model="sucursal.long"
                  :hide-details="true"
                  :label="$t('sucursal.longitud')"
                  :placeholder="$t('sucursal.xxxxxxxxx')"
                  disabled
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6">
                <v-btn
                  block
                  class="white--text"
                  color="red"
                  @click="cancelarCambios()"
                >
                  <v-icon>mdi-backup-restore</v-icon>
                  <span class="ml-2">{{ $t('sucursal.cancelar') }}</span>
                </v-btn>
              </v-col>
              <v-col cols="6">
                <v-btn
                  :disabled="sinCambiosPorGuardar()"
                  block
                  class="white--text"
                  color="primary"
                  @click="guardarDatosSucursal()"
                >
                  <v-icon>mdi-content-save-outline</v-icon>
                  <span class="ml-2">{{ $t('sucursal.guardar') }}</span>
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </div>
    </v-card>
  </v-main>
</template>
<script>
import serviceSucursal from '~/services/serviceSucursal'
import serviceProvincia from '~/services/serviceProvincia'
import serviceLocalidad from '~/services/serviceLocalidad'
import servicePrestador from '~/services/servicePrestador'

export default {
  name: 'SucursalForm',
  props: {
    sucursalId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      sucursal: null,
      sucursalBk: null,
      provincias: null,
      localidades: null,
      showLoading: false,
      showLoadingLocalidades: false,
      showSucces: false,
      mensajeOk: '',
      showError: false,
      mensajeError: ''
    }
  },
  created() {
    this.getPronvicias()
    this.getSucursal()
  },
  methods: {
    async getPronvicias() {
      try {
        const response = await serviceProvincia.getProvincias(
          this.$config.axiosParams
        )
        this.provincias = Object.values(response.data)
      } catch (error) {
        if (error?.response?.status === 401) {
          this.$router.push('/login')
        } else {
          this.showError = true
          this.mensajeError = `Error al obtener las provincias. ${error}`
        }
      }
    },
    async getLocalidadesProvincia(uidProvincia) {
      this.showLoadingLocalidades = true
      try {
        const data = { provincia: uidProvincia }
        const response = await serviceLocalidad.getLocalidadesProvincia(
          this.$config.axiosParams,
          data
        )
        this.localidades = Object.values(response.data)
        this.showLoadingLocalidades = false
      } catch (error) {
        if (error?.response?.status === 401) {
          this.$router.push('/login')
        } else {
          this.showLoadingLocalidades = false
          this.showError = true
          this.mensajeError = `Error al obtener las localidades de la provincia. ${error}`
        }
      }
    },
    async getSucursal() {
      try {
        this.showLoading = true
        const response = await serviceSucursal.getSucursal(
          this.$config.axiosParams,
          this.sucursalId
        )
        this.sucursal = response.data
        this.sucursalBk = { ...this.sucursal }
        if (this.sucursal.provincia_id) {
          this.getLocalidadesProvincia(this.sucursal.provincia_id)
        }
        this.showLoading = false
      } catch (error) {
        if (error?.response?.status === 401) {
          this.$router.push('/login')
        } else {
          this.showLoading = false
          this.showError = true
          this.mensajeError = `Error al obtener los datos de la sucursal. ${error}`
        }
      }
    },
    cambiarProvincia() {
      const index = this.provincias
        .map((p) => p.id)
        .indexOf(this.sucursal.provincia_id)
      this.sucursal.provincia = this.provincias[index].nombre
      this.getLocalidadesProvincia(this.sucursal.provincia_id)
    },
    cambiarLocalidad() {
      const index = this.localidades
        .map((loc) => loc.id)
        .indexOf(this.sucursal.localidad_id)
      this.sucursal.localidad = this.localidades[index].nombre
    },
    cancelarCambios() {
      if (this.sucursal.provincia_id !== this.sucursalBk.provincia_id) {
        this.getLocalidadesProvincia(this.sucursalBk.provincia_id)
      }
      this.sucursal = { ...this.sucursalBk }
    },
    sinCambiosPorGuardar() {
      const aKeys = Object.keys(this.sucursal).sort()
      const bKeys = Object.keys(this.sucursalBk).sort()
      if (aKeys.length !== bKeys.length) {
        return false
      }
      if (aKeys.join('') !== bKeys.join('')) {
        return false
      }
      for (let i = 0; i < aKeys.length; i++) {
        if (this.sucursal[aKeys[i]] !== this.sucursalBk[bKeys[i]]) {
          return false
        }
      }
      return true
    },
    async guardarDatosSucursal() {
      try {
        this.showLoading = true
        await serviceSucursal.guardarSucursal(
          this.$config.axiosParams,
          this.sucursal
        )
        this.showLoading = false
        this.showSucces = true
        this.mensajeOk = 'Se guardaron los datos de la Sucursal con Exito.'
        this.crearSolicitudCambiosSucursal()
        this.getSucursal()
      } catch (error) {
        if (error?.response?.status === 401) {
          this.$router.push('/login')
        } else {
          this.showLoading = false
          this.showError = true
          this.mensajeError = `Error al guardar los datos de la sucursal. ${error}`
        }
      }
    },
    crearSolicitudCambiosSucursal() {
      const modificados = Object.entries(this.sucursal).map(([key, value]) => {
        if (typeof this.sucursalBk[key] === 'undefined') {
          return `${key}=''`
        }

        if (this.sucursalBk[key] !== value) {
          return `${key}=${this.sucursalBk[key]}`
        }

        return null
      })

      const modificadosFiltrados = modificados.filter((value) => {
        return value !== null
      })

      const observacion = {
        solicitud: `Se modifica datos de sucursal ${
          this.sucursalBk.razon_social
        }. Valores anteriores: ${modificadosFiltrados.toString()}`
      }

      try {
        servicePrestador.agregarObservacion(
          this.$config.axiosParams,
          this.sucursalBk.prestador_id,
          observacion
        )
      } catch (error) {
        if (error?.response?.status === 401) {
          this.$router.push('/login')
        } else {
          // eslint-disable-next-line no-console
          console.error(error)
        }
      }
    }
  }
}
</script>
